export enum OrderWayPointTypeEnum {
    ORDER = 'order',
    DRONE = 'drone',
    WAY_POINT =  'wayPoint'
}